import watchGetHistory from './getHistory'

const watchShowHistory = [watchGetHistory];

export default watchShowHistory;
